import { webDarkTheme, webLightTheme } from '@fluentui/react-components';

export type ThemeMode = 'system' | 'light' | 'dark';

const STORAGE_KEY = 'admin-theme';

export const themes = {
  light: webLightTheme,
  dark: webDarkTheme,
} as const;

export const getSystemTheme = (): 'light' | 'dark' => {
  if (typeof window === 'undefined') {
    return 'light';
  }
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

export const getResolvedTheme = (mode: ThemeMode): 'light' | 'dark' => {
  if (mode === 'system') {
    return getSystemTheme();
  }
  return mode;
};

export const getSavedThemeMode = (): ThemeMode => {
  if (typeof window === 'undefined') {
    return 'system';
  }
  try {
    const savedTheme = localStorage.getItem(STORAGE_KEY);
    if (savedTheme === 'light' || savedTheme === 'dark' || savedTheme === 'system') {
      return savedTheme;
    }
  } catch {
    // localStorage not available
  }
  return 'system';
};

export const saveTheme = (theme: ThemeMode): void => {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // localStorage not available
  }
};
